import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { CsrfService } from './csrf/csrf.service';
import { switchMap, from } from 'rxjs';

const CSRF_EXEMPT_URLS = ['/auth/csrf', '/auth/login'];

function needsCsrf(req: HttpRequest<unknown>): boolean {
  const url = req.url;
  return !CSRF_EXEMPT_URLS.some((exempt) => url.includes(exempt));
}

function isInternalApi(req: HttpRequest<unknown>): boolean {
  return req.url.includes('/auth/') && !req.url.includes('/auth/csrf') && !req.url.includes('/auth/login');
}

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  const csrf = inject(CsrfService);

  const method = req.method.toUpperCase();
  const isMutable = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);
  const isInternal = isInternalApi(req);

  if (isInternal && !isMutable) {
    return next(req);
  }

  if (!isMutable || !needsCsrf(req)) {
    return next(req);
  }

  const token = csrf.value;

  if (token) {
    const cloned = req.clone({
      withCredentials: true,
      setHeaders: {
        'X-CSRF-Token': token,
      },
    });
    return next(cloned);
  }

  return from(csrf.fetchToken()).pipe(
    switchMap((token) => {
      const cloned = req.clone({
        withCredentials: true,
        setHeaders: {
          'X-CSRF-Token': token,
        },
      });
      return next(cloned);
    })
  );
};